import { useCallback, useState } from 'react'

export interface UseSidebarCollapseOptions {
  // splitOn removed — split is now internal to VideoPlayer.
}

export interface UseSidebarCollapseResult {
  collapsed: boolean
  autoCollapsed: boolean
  toggle: () => void
  collapse: () => void
  expand: () => void
}

/**
 * Sidebar collapse state for the LC learner page.
 *
 * Memory-only (no localStorage/sessionStorage). Starts collapsed.
 * `autoCollapsed` is always false now — the previous splitOn auto-collapse
 * behavior is removed because split state is internal to VideoPlayer.
 */
export function useSidebarCollapse(
  _options: UseSidebarCollapseOptions = {},
): UseSidebarCollapseResult {
  const [collapsed, setCollapsed] = useState(true)

  const toggle = useCallback(() => setCollapsed((v) => !v), [])
  const collapse = useCallback(() => setCollapsed(true), [])
  const expand = useCallback(() => setCollapsed(false), [])

  return { collapsed, autoCollapsed: false, toggle, collapse, expand }
}
